import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';

interface Props {
  ca: number;
  payroll: number;
  size?: number;
}

const SmallPieChart: React.FC<Props> = ({ ca, payroll, size = 140 }) => {
  // const total = Math.max(1, ca + payroll);
  // const caPct = ca / total;

  const outer = Math.round(size / 2);
  // const inner = Math.max(0, outer - 24);

  const data = [
    { id: 'ca', label: 'CA', value: Math.round(ca), color: '#c8a059' },
    { id: 'payroll', label: 'Masse salariale', value: Math.round(payroll), color: '#b97823ff' },
  ];

  const series = [
    {
      // omit `label` from datum to prevent labels being drawn inside slices
      data: data.map(d => ({ id: d.id, value: d.value, color: d.color })),
      innerRadius: 0,
      outerRadius: outer,
      paddingAngle: 0,
      cornerRadius: 0,
      startAngle: 0,
      endAngle: 360,
      cx: 75,
      cy: 75,
    },
  ];

  const rows = data.map(d => ({ ...d, pct: Math.round((d.value / Math.max(1, data.reduce((a,b)=>a+b.value,0))) * 100) }));

  return (
    <div style={{ width: size, height: size }} className="flex flex-col items-center">
      <div style={{ position: 'relative', width: size, height: size }}>
        <PieChart series={series as any} height={size} width={size} />

       
      </div>

      {/* Legend below the pie */}
      <div className="mt-3 flex flex-row flex-wrap justify-center gap-4">
        {rows.map(r => (
          <div key={r.id} className="flex items-center space-x-2 text-sm ">
            <div style={{ width: 12, height: 12, background: r.color, borderRadius: 2 }} />
            <div className="font-medium">{r.label}</div>
            <div className="text-xs ">{r.pct}%</div>
            <div className="ml-2 text-xs ">{r.value}€</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SmallPieChart;